import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Quest } from '../../../../../quest/src/lib/quest.interface';
import { QuestValueChange } from '../../../../../quest/src/lib/quest-value-change.interface';
import { QuestPartChange } from '../../../../../quest/src/lib/quest-part-change.interface';
import { QuestDisplayType } from '../../../../../quest/src/lib/quest-display-type.enum';
import { QuestionType } from '../../../../../quest/src/lib/question-type.enum';
import { QuestionAppearance } from '../../../../../quest/src/lib/question-appearance.enum';

const checklistModel: Quest = {
      id: 'TestChecklistModel',
      display: QuestDisplayType.single,
      // Not neccessary for the QuestLib
      original: undefined,
      parts: [
        {
          id: 'PartChecklist',
          title: 'Checklist',
          questions: [
            {
              id: 'TestQuestions01',
              type: QuestionType.checklist,
              text: 'To be or not to be?',
              options: [
                {
                  id: 'TestQuestionOption01',
                  text: 'Option01',
                },
                {
                  id: 'TestQuestionOption02',
                  text: '<h1>Option2</h1>',
                },
                {
                  id: 'TestQuestionOption03',
                  text: 'Option03',
                  custom: 'testClass'
                }
              ],
              value: undefined,
              error: false,
              appearance: QuestionAppearance.full,
            },
          ]
        }
      ]
    };

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss']
})
export class ChecklistComponent {

  public model = checklistModel;

  public quest: BehaviorSubject<Quest> = new BehaviorSubject<Quest>(this.model);

  constructor() {
  }
  check(changed: QuestValueChange) {
    console.log('SomethingChanged');
  }

  page(changed: QuestPartChange) {
    // TODO: do something here
    console.log('next/back was pressed!');
  }

  submit(model: any) {
    // TODO: decide what to do here
    console.log('SUBMIT!');
  }

  private onError(translationKey: string) {
    // TODO: decide what to do with errors
    console.log('error');
  }

}
